export const defaultTheme = "dark";

export const redisThemeKey = "REDIS_THEME_KEY";
